import "./IInvestStoreProductsComponents.scss";
import {IComponentOptions, IOnDestroy, IOnInit, IScope} from "angular";
import {IInvestStorePriceMapping} from "../../models/IInvestStorePrices";
import {ReplaySubject, Subject} from "rxjs";
import {StoreProductState} from "../../../common/models/StoreProductState";
import {IInvestStoreViewStore} from "../../service/IInvestStoreViewStore";

export const StoreProducts = "iinvestStoreProducts";

export function storeProducts(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/products/IInvestStoreProductsComponents.html`,
        bindings: {
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: IInvestStoreProductsComponentsController
    };
}

export class IInvestStoreProductsComponentsController implements IOnInit, IOnDestroy {

    public viewStore: IInvestStoreViewStore;

    public prices = IInvestStorePriceMapping;
    public platformState: StoreProductState;

    public hasChangedProducts = false;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private $scope: IScope) {

    }

    public $onInit(): void {
        this.viewStore
            .productStates
            .takeUntil(this.destroyed$)
            .map((state) => state.PLATFORM)
            .subscribe((state) => {
                this.$scope.$applyAsync(() => this.stateChanged(state));
            });
    }

    private stateChanged(state: StoreProductState) {
        this.platformState = state;
        this.hasChangedProducts = state.selected && !state.locked;
    }

    public togglePlatformState() {
        this.viewStore.togglePlatformState();
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
